import Timeout from "@/js/component/Timeout";
import { useRef } from "react";

type Props = {
    /** Stored config values may come back from the database as strings ("67") */
    defaultValue: number | string | null | undefined;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    step?: number;
}

export default function UiRange(props: Props) {
    const ti = useRef(new Timeout(500));

    const handleChange = (v: number) => {
        ti.current.run(() => props.onChange(v));
    };

    const defaultValue = null === props.defaultValue || undefined === props.defaultValue
        ? undefined
        : Number(props.defaultValue);

    return (
        <input
            key={defaultValue}
            type="range"
            className="form-range"
            min={props.min ?? 0}
            max={props.max ?? 100}
            step={props.step ?? 1}
            defaultValue={defaultValue}
            onChange={e => handleChange(+e.target.value)}
        />
    );
}
